import { render, staticRenderFns } from "./EmailVerificiationPrompt.vue?vue&type=template&id=2c3548d6"
import script from "./EmailVerificiationPrompt.vue?vue&type=script&lang=js"
export * from "./EmailVerificiationPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports